export const Agency = {
  Sinclair: 'Sinclair Broadcast Group',
};
